import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({ first_name: "", last_name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await fetch("/api/contact/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (res.ok) setSubmitted(true);
      else setError("Something went wrong. Please try again.");
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="contact-page">
      <div className="study-header">
        <p className="study-eyebrow">Good Distractions</p>
        <h1>Let's build something together</h1>
      </div>
      <p className="auth-hint">
        Have an app idea, need a hand on one already in flight, or just
        want to talk shop about Wordy Whiz? Drop us a line and we'll get
        back to you soon.
      </p>
      <ul className="contact-links">
        <li>
          <a href="mailto:hello@gooddistractions.com" className="contact-link-item">
            <span className="contact-link-icon">@</span>
            hello@gooddistractions.com
          </a>
        </li>
      </ul>

      {submitted ? (
        <div className="contact-success">
          <h3>Message sent!</h3>
          <p>We'll be in touch soon.</p>
        </div>
      ) : (
        <form className="auth-form" onSubmit={handleSubmit}>
          {error && <p className="auth-error">{error}</p>}
          <div className="auth-row">
            <label className="auth-field">
              <span className="ww-label">First Name</span>
              <input className="auth-input" name="first_name" value={formData.first_name} onChange={handleChange} required />
            </label>
            <label className="auth-field">
              <span className="ww-label">Last Name</span>
              <input className="auth-input" name="last_name" value={formData.last_name} onChange={handleChange} required />
            </label>
          </div>
          <label className="auth-field">
            <span className="ww-label">Email</span>
            <input className="auth-input" name="email" type="email" value={formData.email} onChange={handleChange} required />
          </label>
          <label className="auth-field">
            <span className="ww-label">Message</span>
            <textarea className="auth-input" name="message" rows={4} value={formData.message} onChange={handleChange} required />
          </label>
          <div className="auth-actions">
            <button type="submit" className="ww-btn ww-btn--accent">Send message →</button>
          </div>
        </form>
      )}
    </div>
  );
}

export default Contact;
